import axios from '../api/axiosInstance';

export const fetchContactEnquiries = (params) => axios.get('/contact-enquiries', { params });
